import CloseIcon from '@mui/icons-material/Close';
import FolderOffIcon from '@mui/icons-material/FolderOff';
import { IconButton, Typography } from '@mui/material';
import React from 'react';
import { Trans } from 'react-i18next';
import { makeStyles } from 'tss-react/mui';

interface Props {
  open: boolean;

  handleClose(): void;
}

const NoBlacklistItemsAdded: React.FC<Props> = ({ open, handleClose }) => {
  const { classes } = useStyles();

  return open ? (
    <div className={classes.noBlacklistsItemsAdded}>
      <IconButton className={classes.closeButton} onClick={handleClose}>
        <CloseIcon />
      </IconButton>
      <FolderOffIcon className={classes.icon} />
      <Typography className={classes.greyText}>
        <Trans i18nKey={'noBlacklistsItemsAdded'}>
          There are no companies or contacts currently in your global blacklist. To take advantage of the blacklist feature and optimize your outreach
          campaign targeting, click the <strong>Add Contacts</strong> or <strong>Add Companies</strong> button to start adding contacts to the desired
          blacklist category.
        </Trans>
      </Typography>
    </div>
  ) : null;
};

const useStyles = makeStyles()((theme) => ({
  noBlacklistsItemsAdded: {
    position: 'relative',
    overflow: 'auto',
    background: '#FFF',
    borderRadius: '12px',
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '24px',
  },
  icon: {
    fontSize: theme.typography.pxToRem(62),
    marginBottom: '24px',
    color: theme.palette.greys.medium,
  },
  greyText: {
    fontSize: theme.typography.pxToRem(15),
    color: theme.palette.greys.medium,
    maxWidth: '940px',
  },
  closeButton: {
    position: 'absolute',
    top: '8px',
    right: '8px',
    padding: '4px',
    '& .MuiSvgIcon-root': {
      fontSize: theme.typography.pxToRem(20),
    },
  },
}));

export default NoBlacklistItemsAdded;
